import ModelHelper from "./ModelHelper";

const PrivateAreaHelper = class extends ModelHelper {
    /**
     * @property {string}
     */
    name;
    /**
     * @property {number}
     */
    poster;
    /**
     * @property {number}
     */
    poster_small;
    get i18nDataProperty() {
        return "PrivateArea_i18n";
    }
    get displayName() {
        return this.title || this.name;
    }
};

export default PrivateAreaHelper;
